import { Schema as S } from "effect";

import { DeveloperCreditAdjustment } from "../../api/schemas/developer";
import { Direction } from "../../api/schemas/ledger";
import { Dialog } from "../../widgets/dialog";
import { TagInputVariant } from "../developers/model";
import { GenerationConfig, Plan } from "./generator";

export const Feedback = S.Struct({
	kind: S.Literals(["success", "error"]),
	message: S.String,
});

/** Which destructive action the open dialog confirms (plan U8: credits and generated-data deletion confirm too). */
export const PendingConfirm = S.Literals([
	"credit",
	"debit",
	"billing",
	"cleanup",
]);
export type PendingConfirm = typeof PendingConfirm.Type;

export const GenerationPhase = S.Literals([
	"idle",
	"creating-records",
	"editing-records",
	"creating-entries",
	"editing-entries",
	"done",
	"error",
]);
export type GenerationPhase = typeof GenerationPhase.Type;

export const Generation = S.Struct({
	config: GenerationConfig,
	plan: S.Option(Plan),
	phase: GenerationPhase,
	progress: S.Number,
	cancelRequested: S.Boolean,
	error: S.Option(S.String),
	success: S.Option(S.String),
	cleaning: S.Boolean,
});
export type Generation = typeof Generation.Type;

export const Model = S.Struct({
	page: S.Literal("Developer"),
	developerEnabled: S.Boolean,
	tagInputVariant: TagInputVariant,
	amount: S.String,
	notes: S.String,
	submitting: S.Option(Direction),
	lastAdjustment: S.Option(DeveloperCreditAdjustment),
	creditError: S.Option(S.String),
	billingPending: S.Boolean,
	billingFeedback: S.Option(Feedback),
	dialog: Dialog.Model,
	pendingConfirm: S.Option(PendingConfirm),
	generation: Generation,
});
export type Model = typeof Model.Type;

export const isRunning = (generation: Generation): boolean =>
	generation.phase !== "idle" &&
	generation.phase !== "done" &&
	generation.phase !== "error";
